/**
 * セット企画設定画面　セット企画プロモーション商品情報VOクラス
 */
export class KYMW1312SetPlanPromotionGoodsInfoModel {

  // プロモーションＮＯ
  public promotionNo: string = <string>'';

  // プロモーション名称
  public promotionName: string = <string>'';

  // プロモーション区分
  public promotionDiv: string = <string>'';

  // プロモーション区分名
  public promotionDivName: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';

  // 商品案内用商品名
  public guideGoodsName: string = <string>'';

  // 商品案内用規格名
  public guideStandardName: string = <string>'';

  // 消費税区分
  public consumeTaxDiv: string = <string>'';

  // 消費税率
  public consumeTaxRate: string = <string>'';

  // セット企画商品名（漢字）
  public setDelivGoodsName: string = <string>'';

  // セット企画商品名（カナ）
  public setDelivGoodsNameKana: string = <string>'';

  // セット企画規格名（漢字）
  public setDelivStandardName: string = <string>'';

  // セット企画規格名（カナ）
  public setDelivStandardNameKana: string = <string>'';

  // お届け明細用商品名（漢字）
  public deliveryGoodsNameKanji: string = <string>'';

  // お届け明細用商品名（カナ）
  public deliveryGoodsNameKana: string = <string>'';

  // お届け明細用規格名（漢字）
  public deliveryStandardNameKanji: string = <string>'';

  // お届け明細用規格名（カナ）
  public deliveryStandardNameKana: string = <string>'';

  // セット企画区分
  public setPlanDiv: string = <string>'';

  // セット企画区分(オリジナル)
  public setPlanDivOrg: string = <string>'';

  // セット企画区分名称
  public setPlanDivName: string = <string>'';

  // 単品注文可否区分
  public singleOrderFlag: string = <string>'';

  // 単品注文可否区分名称
  public singleOrderFlagName: string = <string>'';

  // 媒体区分
  public mediumType: string = <string>'';

  // いばらき　　取扱フラグ
  public handlingFlgIB: string = <string>'0';

  // いばらき　　供給価格（税込）
  public thisTimeSupplyPriceIB: string = <string>'';

  // いばらき　　仕入価格
  public thisTimeCostPriceIB: string = <string>'';

  // いばらき　　プロモーションフラグ
  public promotionFlgIB: string = <string>'';

  // いばらき　　セット企画数量
  public approvedNumIB: string = <string>'';

  // いばらき　　成立価格
  public approvedPriceIB: string = <string>'';

  // いばらき　　配達リード区分
  public deliveryLeadTimeTypeIB: string = <string>'';

  // いばらき　　配達リード区分名称
  public deliveryLeadTimeTypeNameIB: string = <string>'';

  // とちぎ　　　取扱フラグ
  public handlingFlgTO: string = <string>'0';

  // とちぎ　　　供給価格（税込）
  public thisTimeSupplyPriceTO: string = <string>'';

  // とちぎ　　　仕入価格
  public thisTimeCostPriceTO: string = <string>'';

  // とちぎ　　　プロモーションフラグ
  public promotionFlgTO: string = <string>'';

  // とちぎ　　　セット企画数量
  public approvedNumTO: string = <string>'';

  // とちぎ　　　成立価格
  public approvedPriceTO: string = <string>'';

  // とちぎ　　　配達リード区分
  public deliveryLeadTimeTypeTO: string = <string>'';

  // とちぎ　　　配達リード区分名称
  public deliveryLeadTimeTypeNameTO: string = <string>'';

  // ぐんま　　　取扱フラグ
  public handlingFlgGU: string = <string>'0';

  // ぐんま　　　供給価格（税込）
  public thisTimeSupplyPriceGU: string = <string>'';

  // ぐんま　　　仕入価格
  public thisTimeCostPriceGU: string = <string>'';

  // ぐんま　　　プロモーションフラグ
  public promotionFlgGU: string = <string>'';

  // ぐんま　　　セット企画数量
  public approvedNumGU: string = <string>'';

  // ぐんま　　　成立価格
  public approvedPriceGU: string = <string>'';

  // ぐんま　　　配達リード区分
  public deliveryLeadTimeTypeGU: string = <string>'';

  // ぐんま　　　配達リード区分名称
  public deliveryLeadTimeTypeNameGU: string = <string>'';

  // ちば　　　　取扱フラグ
  public handlingFlgTI: string = <string>'0';

  // ちば　　　　供給価格（税込）
  public thisTimeSupplyPriceTI: string = <string>'';

  // ちば　　　　仕入価格
  public thisTimeCostPriceTI: string = <string>'';

  // ちば　　　　プロモーションフラグ
  public promotionFlgTI: string = <string>'';

  // ちば　　　　セット企画数量
  public approvedNumTI: string = <string>'';

  // ちば　　　　成立価格
  public approvedPriceTI: string = <string>'';

  // ちば　　　　配達リード区分
  public deliveryLeadTimeTypeTI: string = <string>'';

  // ちば　　　　配達リード区分名称
  public deliveryLeadTimeTypeNameTI: string = <string>'';

  // さいたま　　取扱フラグ
  public handlingFlgSA: string = <string>'0';

  // さいたま　　供給価格（税込）
  public thisTimeSupplyPriceSA: string = <string>'';

  // さいたま　　仕入価格
  public thisTimeCostPriceSA: string = <string>'';

  // さいたま　　プロモーションフラグ
  public promotionFlgSA: string = <string>'';

  // さいたま　　セット企画数量
  public approvedNumSA: string = <string>'';

  // さいたま　　成立価格
  public approvedPriceSA: string = <string>'';

  // さいたま　　配達リード区分
  public deliveryLeadTimeTypeSA: string = <string>'';

  // さいたま　　配達リード区分名称
  public deliveryLeadTimeTypeNameSA: string = <string>'';

  // とうきょう　取扱フラグ
  public handlingFlgTK: string = <string>'0';

  // とうきょう　供給価格（税込）
  public thisTimeSupplyPriceTK: string = <string>'';

  // とうきょう　仕入価格
  public thisTimeCostPriceTK: string = <string>'';

  // とうきょう　プロモーションフラグ
  public promotionFlgTK: string = <string>'';

  // とうきょう　セット企画数量
  public approvedNumTK: string = <string>'';

  // とうきょう　成立価格
  public approvedPriceTK: string = <string>'';

  // とうきょう　配達リード区分
  public deliveryLeadTimeTypeTK: string = <string>'';

  // とうきょう　配達リード区分名称
  public deliveryLeadTimeTypeNameTK: string = <string>'';

  // ながの　　　取扱フラグ
  public handlingFlgNA: string = <string>'0';

  // ながの　　　供給価格（税込）
  public thisTimeSupplyPriceNA: string = <string>'';

  // ながの　　　仕入価格
  public thisTimeCostPriceNA: string = <string>'';

  // ながの　　　プロモーションフラグ
  public promotionFlgNA: string = <string>'';

  // ながの　　　セット企画数量
  public approvedNumNA: string = <string>'';

  // ながの　　　成立価格
  public approvedPriceNA: string = <string>'';

  // ながの　　　配達リード区分
  public deliveryLeadTimeTypeNA: string = <string>'';

  // ながの　　　配達リード区分名称
  public deliveryLeadTimeTypeNameNA: string = <string>'';

  // にいがた　　取扱フラグ
  public handlingFlgNI: string = <string>'0';

  // にいがた　　供給価格（税込）
  public thisTimeSupplyPriceNI: string = <string>'';

  // にいがた　　仕入価格
  public thisTimeCostPriceNI: string = <string>'';

  // にいがた　　プロモーションフラグ
  public promotionFlgNI: string = <string>'';

  // にいがた　　セット企画数量
  public approvedNumNI: string = <string>'';

  // にいがた　　成立価格
  public approvedPriceNI: string = <string>'';

  // にいがた　　配達リード区分
  public deliveryLeadTimeTypeNI: string = <string>'';

  // にいがた　　配達リード区分名称
  public deliveryLeadTimeTypeNameNI: string = <string>'';

  // 項番2059 START
  // クルコ　　取扱フラグ
  public handlingFlgKU: string = <string>'0';

  // クルコ　　供給価格（税込）
  public thisTimeSupplyPriceKU: string = <string>'';

  // クルコ　　仕入価格
  public thisTimeCostPriceKU: string = <string>'';

  // クルコ　　プロモーションフラグ
  public promotionFlgKU: string = <string>'';

  // クルコ　　セット企画数量
  public approvedNumKU: string = <string>'';

  // クルコ　　成立価格
  public approvedPriceKU: string = <string>'';

  // クルコ　　配達リード区分
  public deliveryLeadTimeTypeKU: string = <string>'';

  // クルコ　　配達リード区分名称
  public deliveryLeadTimeTypeNameKU: string = <string>'';
  // 項番2059 END

  // 注文受付可否区分
  public acceptDiv: string = <string>'';

  // 供給可能区分
  public supplyDiv: string = <string>'';

  // 業態区分（デイリー）
  public dutiesFormDailyDiv: string = <string>'';

  // 業態区分（スポット）
  public dutiesFormSpotDiv: string = <string>'';

}
